import { render, staticRenderFns } from "./VendorImage.vue?vue&type=template&id=41cd9512"
import script from "./VendorImage.vue?vue&type=script&lang=js"
export * from "./VendorImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports